import React, { useEffect } from 'react';
import { Input } from 'reactstrap';

const SelectTopic = ({
  item,
  topic,
  handleTopicSelect,
  handleEqualTopicSelect,
  handleManualTopicPercentage,
  handleManualPercentageOnTopicChange,
}) => {
  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
    width: '80px',
    display: 'block',
  };

  const isSelectedChecker = () => {
    let arr = [];
    item?.selectedTopics?.map((data) => arr?.push(data?.name));
    const isSelected = arr?.includes(topic?.name);
    return isSelected;
  };
  const isSelected = isSelectedChecker();
  useEffect(() => {
    if (item?.selectedTopics?.length && item?.questionPerSub && item?.isEqual) {
      handleEqualTopicSelect(item);
    }
    if (
      item?.selectedTopics?.length &&
      item?.questionPerSub &&
      !item?.isEqual
    ) {
      handleManualPercentageOnTopicChange(item);
    }
  }, [item?.selectedTopics?.length]);

  const extractPercentageValue = () => {
    let value = 0;
    item?.selectedTopics?.map((item) => {
      if (topic?.name === item?.name) {
        value = +item?.percentageOfQuestion;
      }
    });
    return value;
  };

  // Treat 0 as empty string to allow complete clearing
  let percentageValue = extractPercentageValue();
  let value = item?.isEqual ? '' : (percentageValue === 0 ? '' : percentageValue);


  console.log("ItemSub", item);
  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        width: '45%',
      }}
    >
      <Input
        type='checkbox'
        name='name'
        id={topic}
        disabled={!item?.questionPerSub}
        // value={quizData.name}
        onChange={(e) => handleTopicSelect(e?.target?.checked, item, topic)}
        placeholder='Enter quiz name'
        style={{
          opacity: !item?.questionPerSub ? '.5' : '1',
          margin: '0',
          position: 'inherit',
        }}
        required
        checked={isSelected}
      />
      <label  htmlFor={topic} style={{ color: 'white', margin: '0' }}>
        <span className={item.subjectName == "हिंदी" || item.subjectName == "fgunh" ? `hinditext` : ''}>{topic?.name} </span>({topic?.questionCount || 0})
      </label>
      <Input
        onChange={(e) => {
          const inputValue = e?.target?.value;
          // Allow empty string or convert to number
          const numValue = inputValue === '' ? 0 : +inputValue;
          handleManualTopicPercentage(item, numValue, topic);
        }}
        min={1}
        max={100}
        disabled={item?.isEqual || !isSelected}
        type='number'
        name='name'
        value={value}
        // onChange={handleInputChange}
        style={inputStyle}
        required
      />
      <p style={{ color: 'white', margin: '0' }}>%</p>
    </div>
  );
};

export default SelectTopic;
